import { FC, useContext } from "react";
import DataTable from "../../../../../shared/components/dataTable";
import { useNavigate } from "react-router-dom";
import { SidebarContext } from "../../../../../contexts/SidebarContext";
import useQuery from "../../../../../shared/components/hooks/useQuery";
import Loader from "../../../../../shared/components/loader/linearProgress";
import NoPermissionContent from "../../../../../shared/components/noPermissionBanner";
import SearchBox from "../../../../../layouts/SidebarLayout/Header/SearchBox";
import { TableViewContainer } from "../../../../../shared/components/tableViewContainer";

const RoleList: FC = () => {
  const navigate = useNavigate();
  const { payload, setPayload } = useContext(SidebarContext);

  const { loading, data, fetchData, error } = useQuery("/roles", {
    params: {
      ...payload,
    },
  });

  const roleData = data as any;

  const navigateToDetails = () => {
    navigate("/user-controls/roles/create");
  };

  const roleDisplayColumns = ["name"];
  const titleBarNode = <SearchBox />;
  const titleBar = {
    title: "Roles and Permissions",
    headerTitle: "Roles",
    buttonTitle: "Create",
    titleBarNodes: (roleData?.totalItems || payload.search) && titleBarNode,
    onClick: navigateToDetails,
    disabled: roleData?.entityPermissions
      ? !roleData?.entityPermissions?.includes("Roles and Permissions-Create")
      : false,
    subHeading: "",
    rowCount: roleData?.totalItems,
  };

  return (
    <TableViewContainer titleBar={titleBar}>
      {loading && <Loader />}
      {(error as any)?.statusCode === 403 && <NoPermissionContent />}
      {!loading && !error && (
        <DataTable
          entityName="Roles"
          data={roleData?.items ?? []}
          displayColumns={roleDisplayColumns}
          linkColumn="name"
          linkUrl="/user-controls/roles"
          pagination={{ take: payload.take, skip: payload.skip }}
          setPagination={setPayload}
          totalItems={roleData?.totalItems}
          deleteApiUrl="/roles"
          refetchFunction={fetchData}
          disabled={
            roleData?.entityPermissions
              ? !roleData?.entityPermissions?.includes("Roles and Permissions-Delete")
              : false
          }
        />
      )}
    </TableViewContainer>
  );
};

export default RoleList;
